<template>
  <Circles/>
</template>

<script>
import Circles from "@/components/Circles/Circles";
export default {
  name: "HomePage",
  components: {Circles},
  mounted() {
    this.initTheme();
  },
  data() {
    return {
      theme: 'light',
    }
  },
  watch: {
    theme(val) {
      this.$store.dispatch('setTheme', val);
      this.$vuetify.theme.dark = val === 'dark';
    }
  },
  methods: {
    initTheme() {
      this.theme = this.$store.getters.getTheme;
    }
  }
};
</script>

<style scoped>

</style>